export default __webpack_public_path__ + "static/popups-a05b7e0b10e32fca2b6fefac4878023b.mp4";